import React from "react";
import styles from "./JustCoverBook.module.css";

import { Cover } from "../../Cover/Cover";

export const JustCoverBook = (props) => {

    // props:
    //
    // mediaItem - all book data

    // ----------------------------------------------------- PRE-RENDER

    // ----------------------------------------------------- RENDER
    return (
        <section className={styles.container}>
            <Cover mediaItem = {props.mediaItem} size = {window.screen.width > 500 ? "L" : "M"} loc="JustCoverBook"/>
        </section>
    );
}